import PropTypes from 'prop-types';
import React from 'react';
import MessagePopup from './MessagePopup';
import Button from './Button';
import { Dim, Direction } from '../../constants/components';

const getButtons = props => {
    const buttons = [
        <Button
            ariaLabel="Yes"
            key="yes-button-1"
            className="modal-btn"
            isEnabled={props.isEnabled}
            onClick={props.onConfirm}
            text={props.confirmText}
        />,
        <Button
            ariaLabel="No"
            key="no-button-1"
            className="modal-btn cancel-button"
            isEnabled={props.isEnabled}
            onClick={props.onCancel}
            text={props.cancelText}
        />,
    ];
    return props.direction === Direction.RTL ? buttons : buttons.reverse();
};

const PromptModal = props => (
    <MessagePopup message={props.message} buttons={getButtons(props)} backgroundDim={Dim.FULL} />
);

PromptModal.propTypes = {
    message: PropTypes.string.isRequired,

    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    isEnabled: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    direction: PropTypes.oneOf([Direction.LTR, Direction.RTL]),
};

PromptModal.defaultProps = {
    confirmText: 'Yes',
    cancelText: 'No',
    isEnabled: true,
    direction: Direction.RTL,
};

export default PromptModal;
